export async function checkImageUrl(imageSrc) {
	return new Promise((res, rej) => {
		var img = new Image();
		img.onload = res; 
		img.onerror = rej;
		img.src = imageSrc;
	})
}
